import type { BossSetupContent } from "./setup.types";

export type SetupViewMode = "setup" | "bosses";

// `bossContent` may be undefined (not just null) when a SetupResponse persisted
// to localStorage before the boss-setup feature existed is hydrated on load —
// the field is simply absent. Guard with `!= null` so both cases collapse safely.
export function canShowBossViewSwitch(
  bossContent: BossSetupContent | null | undefined,
  canManage: boolean,
): boolean {
  return bossContent != null && (bossContent.isCreated || canManage);
}

export function resolveSetupView(
  requestedView: SetupViewMode,
  bossContent: BossSetupContent | null | undefined,
  canManage: boolean,
): SetupViewMode {
  return requestedView === "bosses" &&
    canShowBossViewSwitch(bossContent, canManage)
    ? "bosses"
    : "setup";
}
